import { Injectable } from '@angular/core';
import { Analytics } from 'aws-amplify';
import { CompanyService } from './company.service';
import { Company } from 'app/interfaces/company';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  company: Company;

  constructor(private companyService: CompanyService) { }

  recordCustomEvent(name: string): void {
    Analytics.record(name)
  }

  recordCustomEventWithAttributes(name: string, attributes: object): void {
    const company = this.companyService.getCompanySelected();
    Object.assign(attributes, company)
    Analytics.record({
      name: name,
      attributes: attributes
    })
  }
}
